
import { defineComponent } from 'vue';
import { AppCard, AppButton, AppImageHolder } from '@/components';
import { useDuplicateItemDetail } from '@/modules/duplicate/item/model/detail';
import { formatDate, renderTimeUnit, renderOption } from '@/common/utils/helpers';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { DuplicateItemOptions } from '@/modules/duplicate/item/model/mixins';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.ITEM.DETAIL,
    components: { AppCard, AppButton, AppImageHolder },
    setup() {
        const { model, actions } = useDuplicateItemDetail();

        return {
            model,
            formatDate,
            actions,
            renderTimeUnit,
            renderOption,
            DuplicateItemOptions,
            ROUTE_NAME_DUPLICATE,
            ROUTE_NAME_GAME
        };
    }
});
